<template>
  <AdminModal :title="`Aplicar descuento · ${row.name}`" @close="$emit('close')">
    <form id="disc-form" @submit.prevent="submit">
      <p class="ad-note">Precio actual: <strong>{{ money(row.monthlyAmount) }}</strong> al mes ({{ row.plan }}).</p>
      <div class="ad-field">
        <label for="disc-pct">Descuento (%)</label>
        <input id="disc-pct" v-model="percent" type="number" min="1" max="100" step="0.5" class="ad-input" required autofocus />
        <span v-if="preview !== null" class="ad-hint">Pagará {{ money(preview) }} al mes.</span>
      </div>
      <div class="ad-field">
        <label for="disc-until">Vigente hasta (opcional)</label>
        <input id="disc-until" v-model="until" type="date" :min="today" class="ad-input" />
        <span class="ad-hint">Déjalo vacío para que no expire.</span>
      </div>
      <p v-if="error" class="ad-error">{{ error }}</p>
    </form>
    <template #footer>
      <button type="button" class="ad-btn ad-btn--ghost" @click="$emit('close')">Cancelar</button>
      <button type="submit" form="disc-form" class="ad-btn ad-btn--primary" :disabled="busy">{{ busy ? 'Guardando…' : 'Aplicar descuento' }}</button>
    </template>
  </AdminModal>
</template>

<script setup>
import { ref, computed } from 'vue'
import AdminModal from './AdminModal.vue'
import { applyDiscount } from '@/services/superadmin'
import { errorText, money, todayInput } from './adminFormat'

const props = defineProps({ row: { type: Object, required: true } })
const emit = defineEmits(['close', 'done'])

const today = todayInput()
const percent = ref('')
const until = ref('')
const busy = ref(false)
const error = ref('')

const preview = computed(() => {
  const p = Number(percent.value)
  if (!p || p <= 0 || p > 100) return null
  return Math.round((props.row.monthlyAmount * (1 - p / 100) + Number.EPSILON) * 100) / 100
})

async function submit() {
  busy.value = true
  error.value = ''
  try {
    await applyDiscount(props.row.id, percent.value, until.value || undefined)
    emit('done')
  } catch (err) {
    error.value = errorText(err)
  } finally {
    busy.value = false
  }
}
</script>